document.addEventListener('DOMContentLoaded', function () {
  var offerEl = document.getElementById('offer');
  var stickyEl = document.getElementById('sticky');

  window.scrollOffer = function () {
    if (offerEl) offerEl.scrollIntoView({ behavior: 'smooth' });
  };

  var activeTab = 'ss';

  window.switchTab = function (t) {
    activeTab = t;
    var tabSS = document.getElementById('tab-ss');
    var tabOTP = document.getElementById('tab-otp');
    if (tabSS) tabSS.classList.toggle('active', t === 'ss');
    if (tabOTP) tabOTP.classList.toggle('active', t === 'otp');
    document.querySelectorAll('.ss-v').forEach(function (el) {
      el.style.display = t === 'ss' ? '' : 'none';
    });
    document.querySelectorAll('.otp-v').forEach(function (el) {
      el.style.display = t === 'otp' ? '' : 'none';
    });
    syncVariant();
  };

  var variantInput = document.getElementById('offer-variant-id');
  var quantityInput = document.getElementById('offer-quantity');
  var sellingPlanInput = document.getElementById('offer-selling-plan');

  function syncVariant() {
    var selected = document.querySelector('.opt.selected, .hp-opt.selected');
    if (selected && variantInput) {
      variantInput.value = selected.dataset.variantId || '';
    }
    if (selected && quantityInput) {
      quantityInput.value = selected.dataset.quantity || '1';
    }
    if (sellingPlanInput) {
      sellingPlanInput.value = (activeTab === 'ss' && selected) ? (selected.dataset.sellingPlan || '') : '';
    }
  }

  window.selectOpt = function (el) {
    document.querySelectorAll('.opt, .hp-opt').forEach(function (o) {
      o.classList.remove('selected');
    });
    el.classList.add('selected');
    syncVariant();
  };

  // Set initial variant from the pre-selected option
  syncVariant();

  // Handle offer form submit - add to cart and open drawer
  window.handleOfferSubmit = function(e) {
    e.preventDefault();
    if (!variantInput || !variantInput.value) {
      alert('Please select a product option.');
      return false;
    }
    var btn = document.getElementById('offer-submit');
    var btnDefaultHtml = btn ? (btn.dataset.defaultHtml || btn.innerHTML) : '';
    if (btn) {
      btn.innerHTML = 'Adding…';
      btn.disabled = true;
    }
    var quantity = parseInt(quantityInput.value) || 1;
    var sellingPlan = sellingPlanInput ? sellingPlanInput.value : '';
    if (typeof addToCart === 'function') {
      addToCart(variantInput.value, quantity, sellingPlan).then(function() {
        if (btn) {
          btn.innerHTML = 'Added!';
          setTimeout(function() {
            btn.innerHTML = btnDefaultHtml || 'Start Now';
            btn.disabled = false;
            if (window.refreshLucide) refreshLucide();
          }, 2000);
        }
      });
    } else {
      // Fallback to regular form submit
      document.getElementById('offer-form').submit();
    }
    return false;
  };

  // The sticky CTA stays visible at all times (mobile-only, per CSS).
  // No scroll-based show/hide — it must not disappear while scrolling.
  if (stickyEl) {
    stickyEl.classList.remove('is-hidden');
  }

  // Scroll-triggered animations
  var animEls = document.querySelectorAll('[data-anim]');
  if (animEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var duration = el.dataset.duration || '0.7s';
          var delay = el.dataset.delay || '0s';
          el.style.animationDuration = duration;
          el.style.animationDelay = delay;
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    animEls.forEach(function (el) { observer.observe(el); });
  } else {
    // No animation — show everything
    animEls.forEach(function (el) { el.style.opacity = '1'; });
  }

  // Small scroll parallax for the two-gummy visual on the first-order page.
  var gummyParallax = document.querySelector('[data-gummy-parallax]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (gummyParallax && !reducedMotion) {
    var backGummy = gummyParallax.querySelector('[data-gummy-layer="back"]');
    var frontGummy = gummyParallax.querySelector('[data-gummy-layer="front"]');
    var parallaxQueued = false;

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function setGummyOffset(el, x, y) {
      if (!el) return;
      el.style.setProperty('--fo-gummy-x', x.toFixed(2) + 'px');
      el.style.setProperty('--fo-gummy-y', y.toFixed(2) + 'px');
    }

    function updateGummyParallax() {
      parallaxQueued = false;
      var rect = gummyParallax.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewportCenter = viewportHeight / 2;
      var elementCenter = rect.top + rect.height / 2;
      var progress = clamp((viewportCenter - elementCenter) / viewportHeight, -1, 1);

      setGummyOffset(backGummy, progress * -18, progress * 34);
      setGummyOffset(frontGummy, progress * 18, progress * -28);
    }

    function queueGummyParallax() {
      if (parallaxQueued) return;
      parallaxQueued = true;
      window.requestAnimationFrame(updateGummyParallax);
    }

    updateGummyParallax();
    window.addEventListener('scroll', queueGummyParallax, { passive: true });
    window.addEventListener('resize', queueGummyParallax);
  }
});
